import field from "../mixins/field";
import translate from "./i18n";

export default {
    name: 'FormInput',
    mixins: [field],
    methods: {
        handlerChange(event) {
            const { name, value } = event.target;
            this.fieldChange({ name, value })
        }
    },
    i18n: {
        ...translate
    }
}
